import React, { useEffect, useState } from "react";
import {
  LoaderWrapper,
  ManageTransactionLayout,
  PendingApprovalCard,
} from "../../../components";
import {
  MANAGE_RKAAS_ROUTES,
  formFields,
  FLOW_TYPES,
  getAdvancedPathWithParam,
  OPTIONS_DATA_MAPPER,
  INVESTMENT_RECORDS_TO_FETCH,
  manageTransactionFormNames,
  MANAGE_CENSUS_ROUTES,
} from "../../../utils";
import {
  getApprovalLoanCount,
  getApprovalRolloverinCount,
  getApprovalWithdrawalCount,
  getMasterInvestmentBySearchCriteria,
} from "../../../services";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import Logo from "../../../assets/empty-approval.svg";
import {
  ROUTES,
  MANAGE_TRANSACTION_ROUTES,
  ApplicationRoute,
} from "../../../utils";

const ManageApproval = (props) => {
  const id = 1;
  const { history } = props;
  const [filteredValues, setFilteredValues] = useState([]);
  const [isloading, setIsLoading] = useState(true);
  // const [dataLoading, setDataLoading] = useState(true);
  // const formName = manageTransactionFormNames
  // const fields = formFields[formName];
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [pendingLoanCount, setPendingLoanCount] = useState({
    count: 0,
    newLoanCount: 0,
    reFinanceCount: 0,
    reAmortizeCount: 0,
  });

  const [append, setAppend] = useState(false);
  const { response: WithdrawalCount, loading: dataLoad } = useRequest({
    method: getApprovalWithdrawalCount,
    payload: 1, //userId
    defaultResponse: 0,
  });

  const { response: RolloverinCount } = useRequest({
    method: getApprovalRolloverinCount,
    // payload: companyGridpayload,
    defaultResponse: 0,
  });

  useEffect(() => {
    getApprovalLoanCount()
      .then((res) => {
        let temp = { newLoanCount: 0, reFinanceCount: 0, reAmortizeCount: 0 };

        res?.pendingApprovals.map((_) => {
          if (_.loanStatus == "AwaitingApproval")
            temp = { ...temp, newLoanCount: _.count ?? 0 };
          else if (_.loanStatus == "RefinancingRequestAwaitingApproval")
            temp = { ...temp, reFinanceCount: _.count ?? 0 };
          else temp = { ...temp, reAmortizeCount: _.count ?? 0 };
        });
        setPendingLoanCount({
          ...temp,
          count: temp.newLoanCount + temp.reFinanceCount + temp.reAmortizeCount,
        });
      })
      .catch((err) => err);
  }, []);

  const pendingApprovalList = [
    {
      label: "Withdrawal Requests",
      count: WithdrawalCount,
      link: MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL,
    },
    {
      label: "Loan Requests",
      count: pendingLoanCount?.count,
      newLoanCount: pendingLoanCount?.newLoanCount,
      reAmortizeCount: pendingLoanCount?.reAmortizeCount,
      reFinanceCount: pendingLoanCount?.reFinanceCount,
      link: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
    },
    {
      label: "Rollover-in Requests",
      count: RolloverinCount,
      link: MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERIN,
    },
  ];

  const [request, setRequest] = useState({
    search: "",
    from: 0,
    to: INVESTMENT_RECORDS_TO_FETCH,
  });
  useDeepEffect(() => {
    setIsLoading(true);
    getMasterInvestmentBySearchCriteria(request)
      .then((response) => {
        if (response.length < INVESTMENT_RECORDS_TO_FETCH)
          setStopInfiniteScroll(true);
        if (append)
          setFilteredValues((filteredValues) => {
            return [...filteredValues, ...response];
          });
        else setFilteredValues(response);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [request]);

  const onFormSubmit = (values) => {
    setAppend(false);
    setStopInfiniteScroll(false);
    setRequest({
      search: values.search,
      investmentType: values.investmentType,
      investmentStatus: values.investmentStatus,
      from: 0,
      to: INVESTMENT_RECORDS_TO_FETCH,
    });
  };

  const onAddClick = () => {
    const { history } = props;
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_RKAAS_ROUTES.ADD_INVESTMENT,
        pathParam: [FLOW_TYPES.ADD],
      })
    );
  };

  const buttons = [
    {
      label: "New Request",
      variant: "primary",
      type: "button",
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: ROUTES.MANAGE_EMPLOYEE,
          })
        ),
    },
  ];

  return (
    <ManageTransactionLayout
      layoutHeader="Manage Approvals"
      buttons={buttons}
      pageFlow={FLOW_TYPES.ADD}
    >
      {(pendingLoanCount?.count > 0 ||
        WithdrawalCount > 0 ||
        RolloverinCount > 0) && (
        <div className="fw-500" style={{ marginBottom: "10px" }}>
          Request Pending for approval
        </div>
      )}
      <LoaderWrapper isLoading={dataLoad} className="h-100">
        {pendingLoanCount?.count > 0 ||
        WithdrawalCount > 0 ||
        RolloverinCount > 0 ? (
          <div className="d-flex flex-wrap">
            {pendingApprovalList?.map((pending) => {
              return (
                <PendingApprovalCard {...props} pendingApproval={pending} />
              );
            })}
          </div>
        ) : (
          <div>
            <div className="d-flex justify-content-center">
              <img
                className="img"
                style={{
                  width: "494px",
                  height: "369px",
                }}
                src={Logo}
              />
            </div>

            <p
              style={{
                textAlign: "center",
                justifyContent: "center",
                fontWeight: "500",
                fontSize: "24px",
              }}
            >
              Hmm...
            </p>
            <p
              style={{
                textAlign: "center",
                justifyContent: "center",
                fontWeight: "500",
                fontSize: "24px",
              }}
            >
              No Request to be approved
            </p>
          </div>
        )}
      </LoaderWrapper>
    </ManageTransactionLayout>
  );
};

export default ManageApproval;
